import { Text } from "@gcs/design-system/react";
import React, { useEffect } from "react";
import * as S from "./Modal.style";
import { ReactComponent as CrossIcon } from "assets/svgs/cross.svg";
import Backdrop from "../Backdrop";

const Modal = ({ show = false, title, children, onClose }) => {
  useEffect(() => {
    if (show) {
      document
        .getElementById("modal")
        .scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, [show]);
  return (
    show && (
      <>
        <Backdrop onClick={onClose} show={show} />
        <S.ModalContainer id="modal">
          <S.TitleContainer>
            <Text variant="headline-06" color="primary">
              {title}
            </Text>
            <CrossIcon
              onClick={onClose}
              style={{ cursor: "pointer", width: "40px" }}
            />
          </S.TitleContainer>
          <S.Content>{children}</S.Content>
        </S.ModalContainer>
      </>
    )
  );
};

export default Modal;
